import { BaseModel } from '@core/data-access';
import { Expose, Type } from 'class-transformer';
import { IDocument, IDocumentESigning, IDocumentMetadata } from '../interfaces/document.interface';
import { ContentBuilderContentModel } from './content-builder-content.model';
import { ContentBuilderFieldModel } from './content-builder-field.model';
import { DocumentExpirationSettingModel } from './document-expiration-setting.model';
import { ParticipantModel } from './participant.model';
import { Default } from '@core/util';

export class DocumentESigningModel extends BaseModel implements IDocumentESigning {
  @Expose()
  enableESigning!: boolean;

  @Expose()
  provider!: string[];
}

export class DocumentMetadataModel extends BaseModel implements IDocumentMetadata {
  @Default('editable-mode')
  @Expose()
  mode!: 'form-mode' | 'editable-mode';

  @Expose()
  note!: string;

  @Expose()
  caseRefId!: number;

  @Expose()
  @Type(() => DocumentExpirationSettingModel)
  expirationSetting!: DocumentExpirationSettingModel;

  // @Default({})
  @Expose()
  @Type(() => DocumentESigningModel)
  eSigning!: DocumentESigningModel;

  contractDocHash?: string;

  latestNdiSignedUrl?: string;

  participantGroupInfo!: {
    key: number; // = priority
    label: string;
  }[];

  @Expose()
  signingExpiration?: string;

  @Expose()
  caseId?: string;

  @Expose()
  get caseInfo() {
    if (this.caseId) {
      const data = this.caseId.split(':');
      const caseId = data[1];
      let type = '';
      switch (data[0]) {
        case 'lo':
          type = 'letterOffer';
          break;
        case 'fs':
          type = 'masFactSheet';
          break;
      }

      return {
        type,
        caseId,
      };
    }

    return null;
  }
}

// @Exclude()
export class DocumentModel extends BaseModel implements IDocument {
  @Expose()
  id!: number;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  code!: string;

  @Expose()
  businessUnitId!: number;

  @Expose()
  tenantId!: number;

  @Expose()
  signingPortal!: string;

  @Expose()
  signingMethod!: string;

  @Expose()
  content!: ContentBuilderContentModel;

  @Expose()
  @Default('jsonM')
  contentType!: string;

  @Expose()
  docType!: string;

  @Expose()
  version!: number;

  @Expose()
  hash!: string;

  // @Expose({name: 'createdByUser'})
  // @Type(() => UserModel)
  // createdBy!: UserModel;

  @Expose({ name: 'createdByUser' })
  createdBy!: any;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;

  @Expose()
  @Type(() => DocumentMetadataModel)
  metadata!: DocumentMetadataModel;

  @Expose()
  partyData: any;

  @Expose()
  partyViews: any;

  @Expose()
  components: any;

  @Expose()
  items: any;

  @Expose()
  options: any;

  @Expose()
  @Default([])
  @Type(() => ParticipantModel)
  participants!: ParticipantModel[];

  @Expose()
  @Default(ContentBuilderFieldModel.fromJson({}))
  @Type(() => ContentBuilderFieldModel)
  fields!: ContentBuilderFieldModel;

  @Expose()
  dynamicField!: { [x in string]: string };

  @Expose()
  header!: string;

  @Expose()
  footer!: string;
}
